import { Pipe, PipeTransform } from '@angular/core';
import { resolveFileUrl } from '../../mm-web-core/attachment/resolve-url';

@Pipe({
  name: 'attachmentUrl'
})
export class AttachmentUrlPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return resolveFileUrl(value as string);
  }

}
